<template>
  <div class="relative">
    <template v-if="state.slots?.title">
      <slot name="title"></slot>
    </template>
    <li
      class="absolute top-0 left-2 z-10 text-xs text-gray-400 px-1"
      :class="props.titleBg ? 'bg-white' : ''"
      style="top: -9px"
    >
      {{ props.title }}
    </li>
    <template v-if="state.slots?.default">
      <slot name="default"> </slot>
    </template>
  </div>
</template>

<script>
import { onMounted, reactive, useSlots } from "vue";

export default {
  props: {
    title: String,
    titleBg: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const state = reactive({});
    onMounted(() => {
      state.slots = useSlots();
    });
    return { state, props };
  },
};
</script>

<style lang="scss" scoped></style>
